module.exports = __webpack_public_path__ + "static/media/spu_logo.41b71b53.jfif";